import { useMotionStudioModalBase } from 'modules/campaigns/modules/creative-creator/components/AiVariationsCreation/hooks/useMotionStudioModalBase';

export const useMotionStudioModal = props => {
    return useMotionStudioModalBase({ ...props });
};
